import React, {ReactNode} from "react";
import {useAuth} from "../auth/AuthProvider.tsx";
import {useLocation, Navigate} from "react-router-dom";

interface AuthWrapperProps {
    children: ReactNode;
}

const AuthWrapper: React.FC<AuthWrapperProps> = ({children}) => {
    const { loginDto, isAuthLoading } = useAuth();
    const location = useLocation();
    if(isAuthLoading){
        return null;
    }
    if(!loginDto?.logged_in){
        return <Navigate to={'/login?ec=ES001'} state={{from: location}} replace />
    }
    return <>{children}</>;
}
export default AuthWrapper;